module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.11455/images/generate-blog-post.png"